import { Table } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

const GuideBoxUI = props => (
  <div className="guide-box">
    <div className="guide-title-wapper">
      <img className="guide-title-icon" src={props.imgIcon} alt="title-icon"/>
      <p className="guide-title-text">
        <FormattedMessage
          id={props.title.id}
          defaultMessage={props.title.defaultMessage}
        />
      </p>
    </div>
    {
      props.table &&
        <Table columns={props.table.column} dataSource={props.table.data} bordered pagination={false} className={props.table.className ? `guide-table ${props.table.className}` : 'guide-table'} />
    }
    {
      props.description && 
      <FormattedHTMLMessage
        id={props.description.id}
        defaultMessage={props.description.defaultMessage}
      />
    }
  </div>
)

export default GuideBoxUI;
